import React from 'react';
import devImg from './developmentPage.png';

const DevImg = () =>{
    
return (
     <div id="devImg" style={{display:'flex',justifyContent:'center',alignItems:'center', flexDirection:'column',position:'relative'}}>
        <img src={devImg} style={{scale:'0.8'}} alt="U razvoju"/>
        <h3 style={{textAlign:'center', bottom:'1%',position:'absolute'}}>Stranica je u razvoju...</h3>
    </div>
  );
};

export default DevImg;